<template>
  <span>
    <a-tag v-for="item in value" :key="item | label" color="blue">{{item | label}}</a-tag>
  </span>
</template>

<script>
  export default {
    name: "dol-tags",
    props: {
      value: {type: Array, default: () => []},
    },
    filters:{
      label(item){
        return (item && item.name) || item
      }
    }
  }
</script>

<style scoped>

</style>
